const INIT_POSITION = 'INIT_POSITION';
const SET_DEALS = 'SET_DEALS';
const SET_ORDERS = 'SET_ORDERS';
const SET_POSITIONS = 'SET_POSITIONS';
const HISTORY_LOADING_POSITIONS = 'HISTORY_LOADING_POSITIONS';
const HISTORY_LOADING_DEALS = 'HISTORY_LOADING_DEALS';
const HISTORY_LOADING_ORDERS = 'HISTORY_LOADING_ORDERS';

const initialState = {
  positions: [],
  deals: [],
  orders: [],
  loading: {
    positions: false,
    deals: false,
    orders: false
  }
};

export const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_POSITIONS: {
      return {
        ...state,
        positions: action.payload.reverse()
      };
    }
    case SET_DEALS: {
      return {
        ...state,
        deals: action.payload
      };
    }
    case SET_ORDERS: {
      return {
        ...state,
        orders: action.payload
      };
    }
    case HISTORY_LOADING_POSITIONS: {
      return {
        ...state,
        loading: {
          ...state.loading,
          positions: action.payload
        }
      };
    }
    case HISTORY_LOADING_DEALS: {
      return {
        ...state,
        loading: {
          ...state.loading,
          deals: action.payload
        }
      };
    }
    case HISTORY_LOADING_ORDERS: {
      return {
        ...state,
        loading: {
          ...state.loading,
          orders: action.payload
        }
      };
    }
    default:
      return state;
  }
};

export const setDealsData = (payload) => ({
  type: SET_DEALS,
  payload
});

export const setOrdersData = (payload) => ({
  type: SET_ORDERS,
  payload
});

export const setPositionsData = (payload) => ({
  type: SET_POSITIONS,
  payload
});

export const setLoadingPositions = (payload) => ({
  type: HISTORY_LOADING_POSITIONS,
  payload
});
export const setLoadingDeals = (payload) => ({
  type: HISTORY_LOADING_DEALS,
  payload
});
export const setLoadingOrders = (payload) => ({
  type: HISTORY_LOADING_ORDERS,
  payload
});
